import { useEffect, useState, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate } from 'lib/formatter.ts';
import TopNav from 'components/topNav.jsx';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import useStaticList from 'hooks/useStaticList';
import CommonFns from 'functions/common.ts';
import Http from 'services/http2';
import ModalService from 'services/modal';
import CompanyService from 'services/company2.ts';
import { ActionContext } from 'actions/context';
import User from 'services/user2';
import { CONFIG } from '../constants/pending-list.ts';
import EnumService from 'services/enum2';
import { useForm, Controller } from 'react-hook-form';
import Util from 'lib/util.js';

/**
 * 待办|待跟进列表
 *
 * dev
   https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpending%2Flist%2F1&response_type=code&scope=snsapi_base&state=123#wechat_redirect
 * test
   https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx95db6459d1f9938c&redirect_uri=http%3A%2F%2Ftest.xiekeyun.com%2Fmp%2Fpending%2Flist%2F1&response_type=code&scope=snsapi_base&state=123#wechat_redirect
 */

function PendingList(props) {
  const type = props.match.params.type; // '1'.待处理 '2'.待跟进
  document.title = type === '1' ? '待处理任务' : '待跟进任务';
  let config = {
    title: '',
    apiPath: type === '1' ? '/main/waitWorksList' : '/main/followWorksList',
    searchBarPlaceholder: '',
    tabs: ['全部'],
    tabConfig: [
      undefined //全部
    ],
    arrEnumField: [
      {
        mainKey: 'B02_Common_Bill_Type',
        subKey: 'billType',
        value: 'billTypeName'
      }
    ]
  };

  const {
    companyCode,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    listPage,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    setArrSearchField,
    self
  } = useStaticList(props, config);
  const { state, dispatch } = useContext(ActionContext);
  const [billType, setBillType] = useState(undefined);
  const [billTypeList, setBillTypeList] = useState([]);
  const { register, setValue, handleSubmit } = useForm();

  // list 参数设置
  useEffect(() => {
    setArrSearchField(['billShowNo', 'innerName', 'publishName']);
  }, [setArrSearchField]);

  //初始化默认企业
  useEffect(() => {
    ModalService.showLoading(dispatch);
    self.init();
    // 获取业务类型列表
    CompanyService.getBillTypeList(type).then(rs => {
      setBillTypeList(rs);
    });
  }, [self, type, dispatch]);

  //根据依赖多次执行
  useEffect(() => {
    if (billType !== undefined) {
      self.search();
    }
  }, [inited, companyCode, billType, self]);

  self.filter = async function () {
    if (Util.isEmpty(billType)) {
      self.listFilter = self.list.map(item => item);
    } else {
      self.listFilter = self.list.filter(item => {
        return item.billType === billType;
      });
    }
  };

  self.listTransform = async function (arr) {
    if (Array.isArray(arr)) {
      for (let item of arr) {
        let isPurchase = item.innerType === 1;
        let arrLinkPrefix = CONFIG[item.billType]?.arrLinkPrefix || [
          '/pc/',
          '/pc/'
        ];
        let linkPrefix = isPurchase ? arrLinkPrefix[0] : arrLinkPrefix[1];
        let mainKey = CONFIG[item.billType]?.mainKey;
        if (Array.isArray(mainKey)) {
          item.mainKey = isPurchase ? mainKey[0] : mainKey[1];
        } else {
          item.mainKey = mainKey;
        }

        if (item.mainKey) {
          await EnumService.getValue(item.mainKey, item.billStatus).then(
            value => {
              item.billStatusName = value;
            }
          );
        }

        // 详情链接
        let routerLink = linkPrefix + item.companyCode + '/' + item.billXkNo;
        if (item.billType === '40') {
          // 供应商合同
          routerLink += '/6';
        }

        // 企业名称
        item.innerCode = isPurchase
          ? item.innerVendorCode
          : item.innerCustomerCode;
        item.innerName = isPurchase
          ? item.innerVendorName
          : item.innerCustomerName;

        if (companyCode === item.companyCode) {
          item.routerLink = '/mp' + routerLink;
        } else {
          item.routerLink = `/mp/index?companyCode=${item.companyCode}&path='/mp'${routerLink}`;
        }

        if (!['30', '101'].includes(item.billType)) {
          item.queryParams = { companyCode: item.companyCode };
        }

        item.isPurchase = isPurchase;
      }
    }
    ModalService.hideLoading(dispatch);
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (listPage.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={self.searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            {/* <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                  </li>
                ))}
              </ul>
            </div> */}
            <div className="fast-filter-list">
              <div className="fast-filter-item">
                <span className="label">业务类型</span>
                <div className="content">
                  <select
                    value={billType}
                    {...register('billType', {
                      onChange: e => {
                        handleReset();
                        setBillType(e.target.value);
                      }
                    })}
                  >
                    <option key={0} value={''}>
                      {'--请选择--'}
                    </option>
                    {billTypeList.map((row, j) => (
                      <option key={j} value={row.id}>
                        {row.text}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  listPage.map((item, index) => (
                    <Link
                      to={item.routerLink}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.billShowNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                item.mainKey,
                                item.billStatus,
                                item.isPurchase,
                                1
                              )
                            }
                          >
                            {item.billStatusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>业务类型</label>
                          <div>{item.billTypeName}</div>
                        </li>
                        <li>
                          <label>供应商/客户</label>
                          <div>
                            {item.innerName}({item.innerCode})
                          </div>
                        </li>
                        <li>
                          <label>发布日期</label>
                          <div>{formatDate(item.publishTime)}</div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.publishName}</div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!state.showLoading && listPage.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={state.showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

PendingList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(PendingList);
